import { COLOR_MEDIUM_ORANGE_600, COLOR_GRAY_600, COLOR_GRAY_1000, } from '../../../themes/Light/colors.values';
export function getAccentColor(transformer) {
    return Object.freeze({
        gray600: transformer.accentColor(COLOR_GRAY_600),
        gray1000: transformer.accentColor(COLOR_GRAY_1000),
        mediumOrange600: transformer.accentColor(COLOR_MEDIUM_ORANGE_600),
    });
}
